(function() { window.GUID_214a9a2b_ce7f_4836_8eb0_0b2a121d3f2f = { getGuid: function() { return "214a9a2b-ce7f-4836-8eb0-0b2a121d3f2f"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        var Base;
        (function (Base) {
            class BaseControl {
            }
            Base.BaseControl = BaseControl;
        })(Base = Controls.Base || (Controls.Base = {}));
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=BaseControl.js.map
